import { Component  } from 'react';
import { connect } from "react-redux";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import { listAgentMetabaseReports, assignUnassignDashboard } from "./../../../config/reseller_api_calls";
import HelperClass from "./../../../config/helperClass";
import { addSettings, addMsaInfo } from "../../../actions";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import { Fileupload } from "../../../components/Image/Fileupload";
import PageTitle from "../ExtraComponents/PageTitle";
import DataTableExtended from "../../../components/Tables/DataTableExtended";
import { TableLoader } from "../../../components/ContentLoaders/newLoaders/TableLoader";
import Tooltip from "@material-ui/core/Tooltip";

const auth = new HelperClass();

class UserReports extends Component {
  constructor() {
    super();
    this.state = {
      tableData: [],
      errorMessage: "",
      agentId: "",
      successMessage: "",
      waitMessage: "",
      tableLoader: true,
      signup_link: "",
      client_login_link: "",
      copied: false,
      copied_client: false,
      copied2: false,
      cpied_value: "",
      current_id: "",
      reg_button: false,
      cancel_button: false,
      tableLoader: true,
      login_url: "",
      logo: "",
      signature_image: "",
      reports_allowed: "",
      is_dashboard: "",
      default_report_id: "",
      errorMessageReassign: "",
      successMessageReassign: "",
      assign_button: false,
      dashboardText: "",
      dashboardTitle: "",
      columnServices: [
        { name: "title", label: "Title" },
        {
          name: "created_at",
          label: "Created Date",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{auth.formatDateTime(value)}</div>;
            },
          },
        },
        {
          name: "published_at",
          label: "Published Date",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{auth.formatDateTime(value)}</div>;
            },
          },
        },
        {
          name: "status",
          label: "Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setStatus(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "report_status",
          label: "Published Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setStatusPublished(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "url",
          label: "Report",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setReportLink(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "id",
          label: "Action",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setEditLink(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "is_dashboard",
          label: "Action",
          options: {
            display: false,
          },
        },
      ],
    };
  }

  async componentDidMount() {
    const servicesResponce = await listAgentMetabaseReports(
      auth.getAccount(),
      auth.getToken()
    );

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "integration_missing"
    ) {
      //window.location.replace("/error");
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
        reports_allowed: "No",
      });
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message !== "integration_missing"
    ) {
      //window.location.replace("/error");
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
      });
    } else if (servicesResponce.data.status === 200) {
      this.setState({
        tableData: servicesResponce.data.data,
        tableLoader: false,
        tableLoaderListing: false,
        reports_allowed: "Yes",
      });
    } else {
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
      });
      //window.location.replace("/error");
    }
  }

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  setStatus = (value, tableMeta) => {
    let domain_str = value;
    //console.log("domain_str: ", domain_str);
    if (domain_str === "processing") {
      return (
        <div>
          <span className="badge badge-dim badge-danger">
            {" "}
            <em className="icon ni ni-alert-c" title="Active"></em> In process
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span className="badge badge-success">
            {" "}
            <em className="icon ni ni-done "></em> Processed
          </span>
        </div>
      );
    }
  };

  setStatusPublished = (value, tableMeta) => {
    let domain_str = value;
    //console.log("domain_str: ", domain_str);
    if (domain_str === 0) {
      return (
        <div>
          <span className="badge badge-dim badge-danger">
            {" "}
            <em className="icon ni ni-alert-c" title="Active"></em> Not
            Published
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span className="badge badge-success">
            {" "}
            <em className="icon ni ni-done "></em> Published
          </span>
        </div>
      );
    }
  };

  setReportLink = (value, tableMeta) => {
    let domain_str = value;
    let report_id = tableMeta.rowData[6];
    let is_published = tableMeta.rowData[4];
    if (domain_str && domain_str !== "") {
      if (is_published === 1) {
        return (
          <Tooltip title="View report">
            <a
              onClick={() =>
                this.addMenuHistory("/viewAgentRequest/" + report_id)
              }
              style={{ cursor: "pointer" }}
            >
              <em
                className="icon ni ni-reports text-primary"
                style={{ fontSize: "22px" }}
              ></em>
            </a>
          </Tooltip>
        );
      } else {
        return "---";
      }
    } else {
      return "---";
    }
  };

  setEditLink = (value, tableMeta) => {
    let domain_str = value;
    //console.log("domain_str: ", domain_str);
    let status = tableMeta.rowData[3];
    let is_published = tableMeta.rowData[4];
    let dashboard_enabled = tableMeta.rowData[7];
    if (domain_str && domain_str !== "") {
      return (
        <>
          <Tooltip title="Edit report">
            <a
              onClick={() =>
                this.addMenuHistory("/editAgentRequest/" + domain_str)
              }
              style={{ cursor: "pointer" }}
            >
              <em
                className="icon ni ni-edit text-primary"
                style={{ fontSize: "22px" }}
              ></em>
            </a>
          </Tooltip>

          {is_published === 1 && status === "processed" ? (
            <>
              {dashboard_enabled === "Yes" ? (
                <Tooltip
                  title="This report is currently enabled as a dashboard."
                  placement="left"
                >
                  <a
                    onClick={() =>
                      this.set_unset_dashboard(domain_str, dashboard_enabled)
                    }
                    style={{ cursor: "pointer", marginLeft: "5px"}}
                  >
                    <em
                      className="icon ni ni-dashboard text-success"
                      style={{ fontSize: "22px", borderLeft: "1px solid rgb(0 0 0 / 87%)", paddingLeft: "5px" }}
                    ></em>
                  </a>
                </Tooltip>
              ) : (
                <Tooltip
                  title="You can set this report as your dashboard once it has been processed and published."
                  placement="left"
                >
                  <a
                    onClick={() =>
                      this.set_unset_dashboard(domain_str, dashboard_enabled)
                    }
                    style={{ cursor: "pointer", marginLeft: "5px"}}
                  >
                    <em
                      className="icon ni ni-dashboard text-dark"
                      style={{ fontSize: "22px", borderLeft: "1px solid rgb(0 0 0 / 87%)", paddingLeft: "5px" }}
                    ></em>
                  </a>
                </Tooltip>
              )}
            </>
          ) : null}
        </>
      );
    } else {
      return "---";
    }
  };

  set_unset_dashboard = async (report_id, is_dashboard) => {
    let dashboardTitle = "Set as Dashboard";
    let dashboardText = "Are you sure you want to set this report as the dashboard?";
    if(is_dashboard === "Yes"){
      dashboardTitle = "Unset Dashboard";
      dashboardText = "Are you sure you want to remove this report as the dashboard?";
    }
    this.setState({
      is_dashboard: is_dashboard,
      default_report_id: report_id,
      assign_button: false,
      dashboardText: dashboardText,
      dashboardTitle: dashboardTitle
    });
    window.$("#modalAssignAlert").modal("show");
  };

  assign_unassign_dashboard = async () => {
    const { is_dashboard, default_report_id } = this.state;
    this.setState({
      errorMessageReassign: "",
      successMessageReassign: "",
      assign_button: true
    });
    const servicesResponce = await assignUnassignDashboard(
      auth.getAccount(),
      auth.getToken(),
      default_report_id,
      is_dashboard
    );

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "not_found"
    ) {
      //window.location.replace("/error");
      this.setState({
        errorMessageReassign: "Report not found.",
        successMessageReassign: "",
        assign_button: false
      });
    } else if (servicesResponce.data.status === 200) {
      let errorText = "Report successfully set as the dashboard. Please wait while the page refreshes."
      if(is_dashboard === "Yes"){
        errorText = "Report successfully removed as the dashboard. Please wait while the page refreshes."
      }
      this.setState({
        errorMessageReassign: "",
        successMessageReassign: errorText,
        //assign_button: false
      });
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    } else {
      this.setState({
        errorMessageReassign: "There is some error while processing your request.",
        successMessageReassign: "",
        assign_button: false
      });
      //window.location.replace("/error");
    }
  };

  modalHideReassign = (id) => {
    window.$("#"+id).modal("hide");
  };

  render() {
    return (
      <div className="nk-content ">
        <div className="container-fluid">
          {/* MSA WARNING  START*/}
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}
          {/* MSA WARNING END */}
          <div className="nk-content-inner">
            <div className="nk-content-body">
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitle name="Reports" icon="icon ni ni-reports" />
                    </h3>
                  </div>
                  <div className="nk-block-head-content" id="HeadContent">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="pageMenu"
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a>
                      <div
                        className="toggle-expand-content"
                        data-content="pageMenu"
                      >
                        <ul className="nk-block-tools g-3">
                          {this.state.reports_allowed === "Yes" ? (
                            <li className="nk-block-tools-opt">
                              <a
                                onClick={() =>
                                  this.addMenuHistory("/requestAgentReport")
                                }
                                style={{
                                  color: "#fff",
                                }}
                                className="btn btn-primary"
                              >
                                <em className="icon ni ni-plus-round"></em>
                                <span>Request Report</span>
                              </a>
                            </li>
                          ) : null}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="nk-block">
                <div className="row g-gs">
                  {/* Table 5th Col Start */}
                  <div className="col-xxl-12">
                    <div className="nk-block nk-block-lg">
                      <div className="card card-bordered">
                        <div className="card-inner">
                          {this.state.errorMessage !== "" ? (
                            <div
                              className="example-alert example-alert-revoke mt-3 mb-3"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.tableLoader === true ? (
                            TableLoader()
                          ) : (
                            <>
                              {this.state.reports_allowed === "Yes" ? (
                                <DataTableExtended
                                  columns={this.state.columnServices}
                                  tableData={this.state.tableData}
                                  title=""
                                />
                              ) : this.state.reports_allowed === "No" ? (
                                <div
                                  className="example-alert example-alert-revoke mt-3 mb-3"
                                  style={{ marginBottom: "15px" }}
                                >
                                  <div className="alert alert-pro alert-danger">
                                    <div className="alert-text">
                                      <h4>Missing Integration</h4>
                                      <p>
                                        Reports are not enabled. Please contact
                                        administrator to enable it.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Table 5th Col End */}
                </div>
              </div>
            </div>
          </div>
          {/* MODAL REASSIGN AGREEMENT */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalAssignAlert"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <a
                            style={{ cursor: "pointer" }}
                            className="close"
                            onClick={() => {
                              this.modalHideReassign("modalAssignAlert");
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-body modal-body-lg text-center">
                            <div className="nk-modal">
                              <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-repeat bg-success"></em>
                              <h4 className="nk-modal-title">
                                {this.state.dashboardTitle}
                              </h4>
                              <div className="nk-modal-text">
                                {this.state.errorMessageReassign !== "" ? (
                                  <div
                                    className="example-alert"
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-danger">
                                      <div className="alert-text">
                                        <h4>Error</h4>
                                        <p>{this.state.errorMessageReassign}</p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                {this.state.successMessageReassign !== "" ? (
                                  <div
                                    className="example-alert"
                                    style={{ marginBottom: "15px" }}
                                  >
                                    <div className="alert alert-pro alert-success">
                                      <div className="alert-text">
                                        <h4>Success</h4>
                                        <p>
                                          {this.state.successMessageReassign}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                                <div className="caption-text">
                                  {this.state.dashboardText}
                                </div>
                              </div>
                              <div className="nk-modal-action">
                                {this.state.assign_button === true ? (
                                  <button
                                    className="btn btn-lg btn-primary"
                                    type="button"
                                    disabled
                                  >
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    <span> Loading... </span>
                                  </button>
                                ) : (
                                  <>
                                    <a
                                      style={{ cursor: "pointer", color: "#fff" }}
                                      className="btn btn-lg btn-mw btn-primary"
                                      onClick={() => {
                                        this.modalHideReassign("modalAssignAlert");
                                      }}
                                      disabled={this.state.disabled}
                                    >
                                      CANCEL
                                    </a>
                                    {"  "}
                                    <a
                                      style={{ cursor: "pointer", color: "#fff" }}
                                      className="btn btn-lg btn-mw btn-success"
                                      onClick={() => {
                                        this.assign_unassign_dashboard();
                                      }}
                                      disabled={this.state.disabled}
                                    >
                                      Submit
                                    </a>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* MODAL REASSIGN AGREEMENT */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(UserReports);
